import { Optional, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translate',
    standalone: true,
    pure: false
})
export class TranslateCompatPipe implements PipeTransform {
    constructor(@Optional() private readonly translateService?: TranslateService) {}

    transform(value: unknown, params?: Record<string, unknown>): string {
        if (typeof value !== 'string' || !value) {
            return value as string;
        }

        if (!this.translateService) {
            return value;
        }

        try {
            const translated = this.translateService.instant(value, params);
            return typeof translated === 'string' && translated ? translated : value;
        } catch {
            return value;
        }
    }
}
